<template>
  <a-card :bordered="false">
    <div class="table-page-search-wrapper">
      <a-form layout="inline">
        <a-row :gutter="48">
          <a-col :md="6" :sm="24">
            <a-form-item label="关键字">
              <a-input v-model="queryParam.keywords" allowClear  placeholder="搜索关键字"/>
            </a-form-item>
          </a-col>
          <a-col :md="6" :sm="24">
            <a-form-item label="状态">
              <a-select v-model="queryParam.status" placeholder="请选择"
                        allowClear >
                <a-select-option value="1">审核成功</a-select-option>
                <a-select-option value="2">等待审核</a-select-option>
                <a-select-option value="3">审核失败</a-select-option>
              </a-select>
            </a-form-item>
          </a-col>
          <a-col :md="6" :sm="24">
            <a-form-item label="省市">
              <a-cascader
                :options="areaOptions"
                placeholder="请选择地区"
                v-model="queryParam.namekeys"
                changeOnSelect
              />
            </a-form-item>
          </a-col>


          <a-col :md="!advanced && 6 || 24" :sm="24">
            <span class="table-page-search-submitButtons" :style="advanced && { float: 'right', overflow: 'hidden' } || {} ">
              <a-button type="primary" @click="onSearch">查询</a-button>
              <a-button style="margin-left: 8px" @click="() => queryParam = {}">重置</a-button>

            </span>
          </a-col>
        </a-row>
      </a-form>
    </div>

    <div class="table-operator"  >
      <a-button @click="download(1)">
        导出
        <a-icon type="download" />
      </a-button>
    </div>

    <s-table
      ref="table"
      size="default"
      :columns="columns"
      :data="loadData"
      :alert="{ show: true, clear: () => { this.selectedRowKeys = [] } }"
      :rowSelection="{ selectedRowKeys: selectedRowKeys, onChange: onSelectChange }"
    >
      <span slot="danwei" slot-scope="text,record">
          <div style="margin-left: 10px; float: left">
            {{record.name}}  ({{record.code}})
            <br/>
            {{record.num}}
            <br/>
            注册时间 {{record.regist_date|timeFormat}}
            <br/>
            <span style="color: #999">{{record.province}}{{record.city}}{{record.county}}</span>
          </div>
      </span>
      <span slot="grade" slot-scope="text,record">
        <p v-show="record.code>0"><a-tag>{{record.code}}</a-tag></p>
        <p v-if="record.wudaograde">舞蹈{{record.wudaograde}}级</p>
        <p v-if="record.jiqiaograde">技巧{{record.jiqiaograde}}级</p>
      </span>
      <span slot="status" slot-scope="text,record">
        <a-tag v-if="record.status==1" color="green">审核成功</a-tag>
        <a-tag v-else-if="record.status==2" color="red" >待审核</a-tag>
        <a-tag v-else-if="record.status==3">审核失败</a-tag>
      </span>
      <span slot="action" slot-scope="text,record">
        <template >
          <a v-if="record.cert_url" @click="downloadCert(record)">下载证书</a>
        </template>
      </span>
    </s-table>



    <a-modal
            title="操作"
            :width="1200"
            :bodyStyle="{maxHeight:'500px','overflowY':'scroll'}"
            v-model="visible"
            @ok="handleOk"
    >
      <a-spin :spinning="saveLoading">
        <a-form :form="form" >
          <a-row :gutter="48">
            <a-col :md="12" :sm="24">
          <a-form-item
                  :labelCol="labelCol"
                  :wrapperCol="wrapperCol"
                  label="单位"
                  hasFeedback
            >
            <a-input v-model="formData.danwei"
                     placeholder="请输入单位名称"/>
          </a-form-item>
              </a-col>
            <a-col :md="12" :sm="24">
              <a-form-item
                      :labelCol="labelCol"
                      :wrapperCol="wrapperCol"
                      label="联系人"
                      hasFeedback
              >
                <a-input v-model="formData.ldname"
                          placeholder="请输入联系人"/>
              </a-form-item>

              </a-col>
            </a-row>
          <a-row :gutter="48">
            <a-col :md="12" :sm="24">
              <a-form-item
                      :labelCol="labelCol"
                      :wrapperCol="wrapperCol"
                      label="微信号"
                      hasFeedback
              >
                <a-input v-model="formData.weixin"
                         placeholder="请输入微信号"/>
              </a-form-item>
            </a-col>
            <a-col :md="12" :sm="24">
              <a-form-item
                      :labelCol="labelCol"
                      :wrapperCol="wrapperCol"
                      label="手机号"
                      hasFeedback
              >
                <a-input v-model="formData.phone"
                         placeholder="请输入手机号"/>
              </a-form-item>
              </a-col>
            </a-row>
          <a-row :gutter="48">
            <a-col :md="12" :sm="24">
              <a-form-item
                      :labelCol="labelCol"
                      :wrapperCol="wrapperCol"
                      label="邮箱"
                      hasFeedback
              >
                <a-input v-model="formData.email"
                         placeholder="请输入邮箱"/>
              </a-form-item>
            </a-col>
            <a-col :md="12" :sm="24">
              </a-col>
            </a-row>
          <a-row :gutter="48">
            <a-col :md="12" :sm="24">
              <a-form-item
                      :labelCol="labelCol"
                      :wrapperCol="wrapperCol"
                      label="省市"
                      hasFeedback
              >

                <a-cascader :options="areaOptions" placeholder="请选择地区" v-model="formData.areas" changeOnSelect />

              </a-form-item>
            </a-col>
            <a-col :md="12" :sm="24">
              <a-form-item
                      :labelCol="labelCol"
                      :wrapperCol="wrapperCol"
                      label="地址"
                      hasFeedback
              >
                <a-input v-model="formData.address"
                         placeholder="请输入详细地址"/>
              </a-form-item>
              </a-col>
            </a-row>

            <a-col :md="48" :sm="24">
              <a-form-item
                      :labelCol="{
          xs: { span: 12 },
          sm: { span: 4 }}"
                      :wrapperCol="{
          xs: { span: 24 },
          sm: { span: 12 }}"
                      label="报名状态"
                      hasFeedback
              >
              <a-radio-group v-model="formData.memberstatus" button-style="solid">
                <a-radio-button :value="1">
                  联系人信息
                </a-radio-button>
                <a-radio-button :value="2">
                  人员信息
                </a-radio-button>
                <a-radio-button :value="3">
                  申报信息
                </a-radio-button>
                <a-radio-button :value="4"  :disabled="formData.memberstatus==1">
                  确认订单
                </a-radio-button>
                <a-radio-button :value="6" :disabled="formData.memberstatus==1">
                  报名成功
                </a-radio-button>
              </a-radio-group>

            </a-form-item>
              </a-col>
          </a-row>



          <a-divider>人员信息</a-divider>

          <a-table :columns="subjectColumns" :data-source="formData.member_list" :pagination="false">
            <p slot="extra_field" slot-scope="record" style="margin: 0">
            </p>
            <p slot="name" slot-scope="text,record" >
              {{record.name}} ({{record.sex}})
              <br/>
              {{record.num}}
            </p>
            <p slot="service" slot-scope="text,record" >
              ({{record.service_name}}) ¥{{record.price}}
            </p>
            <template slot="action" slot-scope="text,record,index">
              <a href="javascript:;" @click="onEditUser(record)">编辑</a>
              <a-divider type="vertical" />
            </template>
          </a-table>

          <a-divider>发票信息</a-divider>
          <a-row :gutter="48">
            <a-col :md="12" :sm="24">
              <a-form-item
                      :labelCol="labelCol"
                      :wrapperCol="wrapperCol"
                      label="抬头"
                      hasFeedback
              >
                <a-input v-model="formData.fapiao_taitou"
                         placeholder="请输入抬头"/>
              </a-form-item>
            </a-col>
            <a-col :md="12" :sm="24">
              <a-form-item
                      :labelCol="labelCol"
                      :wrapperCol="wrapperCol"
                      label="税号"
                      hasFeedback
              >
                <a-input v-model="formData.fapiao_shuihao"
                         placeholder="请输入税号"/>
              </a-form-item>

            </a-col>
          </a-row>
          <a-row :gutter="48">
            <a-col :md="12" :sm="24">
              <a-form-item
                      :labelCol="labelCol"
                      :wrapperCol="wrapperCol"
                      label="发票备注"
                      hasFeedback
              >
                <a-input v-model="formData.fapiao_beizhu"
                         placeholder="请输入发票备注"/>
              </a-form-item>
            </a-col>
            <a-col :md="12" :sm="24">
              <a-form-item
                      :labelCol="labelCol"
                      :wrapperCol="wrapperCol"
                      label="接收邮箱"
                      hasFeedback
              >
                <a-input v-model="formData.fapiao_email"
                         placeholder="请输入接收邮箱"/>
              </a-form-item>

            </a-col>
          </a-row>
          <a-row :gutter="48">
            <a-col :md="12" :sm="24">
              <a-form-item
                      :labelCol="labelCol"
                      :wrapperCol="wrapperCol"
                      label="接收手机"
                      hasFeedback
              >
                <a-input v-model="formData.fapiao_phone"
                         placeholder="请输入接收手机"/>
              </a-form-item>
            </a-col>
            <a-col :md="12" :sm="24">
            </a-col>
          </a-row>


          <a-divider>操作日志</a-divider>
          <a-timeline>
            <a-timeline-item v-for="log in formData.loglist" :key="log.id">
              {{log.create_time|timeFormat}}
              <b>{{log.user_name}}</b>
              {{log.title}}
              <span v-if="log.note" class="gray">备注:{{log.note}}</span>
            </a-timeline-item>
          </a-timeline>
        </a-form>

      </a-spin>
      <template slot="footer">
        <a-button key="cancel" @click="handleCancel">取消</a-button>
        <a-button key="forward" :loading="saveLoading" type="primary" @click="handleOk">保存</a-button>
      </template>
    </a-modal>




    <a-modal
            title="操作"
            :width="1200"
            :bodyStyle="{maxHeight:'500px','overflowY':'scroll'}"
            v-model="orderVisible"
            @ok="handleOrderOk"
    >
      <a-spin :spinning="saveLoading">
        <a-form :form="form" >
          <a-row :gutter="48">
            <a-col :md="12" :sm="24">
              <a-form-item
                      :labelCol="labelCol"
                      :wrapperCol="wrapperCol"
                      label="单位"
                      hasFeedback
              >
                {{orderFormData.danwei}}
              </a-form-item>
            </a-col>
            <a-col :md="12" :sm="24">
              <a-form-item
                      :labelCol="labelCol"
                      :wrapperCol="wrapperCol"
                      label="联系人"
                      hasFeedback
              >
                {{orderFormData.ldname}}
              </a-form-item>
            </a-col>
          </a-row>

          <a-row :gutter="48">
            <a-col :md="12" :sm="24">
              <a-form-item
                      :labelCol="labelCol"
                      :wrapperCol="wrapperCol"
                      label="应付"
                      hasFeedback
              >
                <a-input v-model="orderFormData.pay_price" allowClear  placeholder="应付金额"/>
              </a-form-item>
            </a-col>
          </a-row>


          <a-row :gutter="48">
            <a-col :md="12" :sm="24">
              <a-form-item
                      :labelCol="labelCol"
                      :wrapperCol="wrapperCol"
                      label="线上实付"
                      hasFeedback
              >
                {{orderFormData.payed_price}}
              </a-form-item>
            </a-col>
            <a-col :md="12" :sm="24">
              <a-form-item
                      :labelCol="labelCol"
                      :wrapperCol="wrapperCol"
                      label="线上支付时间"
                      hasFeedback
              >
                {{orderFormData.pay_time_str}}
              </a-form-item>
            </a-col>
          </a-row>

          <a-row>
          <a-col :md="48" :sm="24">
              <a-form-item
                      :labelCol="{
          xs: { span: 12 },
          sm: { span: 4 }}"
                      :wrapperCol="{
          xs: { span: 24 },
          sm: { span: 12 }}"
                      label="支付状态"
                      hasFeedback
              >
                <a-radio-group v-model="orderFormData.status" button-style="solid">
                  <a-radio-button :value="1">
                    未支付
                  </a-radio-button>
                  <a-radio-button :value="2">
                    支付成功
                  </a-radio-button>
                </a-radio-group>

              </a-form-item>
            </a-col>
          </a-row>

          <a-col :md="48" :sm="24">
            <a-form-item
                    :labelCol="{
          xs: { span: 12 },
          sm: { span: 4 }}"
                    :wrapperCol="{
          xs: { span: 24 },
          sm: { span: 12 }}"
                    label="支付方式"
                    hasFeedback
            >
              {{orderFormData.pay_type_name}}
            </a-form-item>
          </a-col>
          </a-row>


          <a-row>
            <a-col :md="48" :sm="24">
              <a-form-item
                      :labelCol="{
          xs: { span: 12 },
          sm: { span: 4 }}"
                      :wrapperCol="{
          xs: { span: 24 },
          sm: { span: 12 }}"
                      label="管理员备注"
                      hasFeedback
              >
                <a-textarea v-model="orderFormData.adminnote" placeholder="" auto-size />
              </a-form-item>
            </a-col>
          </a-row>

        </a-form>

      </a-spin>
      <template slot="footer">
        <a-button key="cancel" @click="handleOrderCancel">取消</a-button>
        <a-button key="forward" :loading="saveLoading" type="primary" @click="handleOrderOk">保存</a-button>
      </template>
    </a-modal>



    <a-modal
            title="人员操作"
            :width="1000"
            :bodyStyle="{maxHeight:'500px','overflowY':'scroll'}"
            v-model="userFormVisible"
            @ok="handleUserFormOk"
    >
      <a-spin :spinning="saveLoading">
        <a-form :form="form3" >
          <a-row :gutter="48">
            <a-col :md="12" :sm="24">
              <a-form-item
                      :labelCol="labelCol"
                      :wrapperCol="wrapperCol"
                      label="姓名"
                      hasFeedback
              >
                <a-input  v-decorator="[
              'name',
              {rules: [{ required: true, message: '请输入姓名' }]}
            ]"
                          placeholder="请输入姓名"/>
              </a-form-item>
            </a-col>

            <a-col :md="12" :sm="24">
              <a-form-item
                      :labelCol="labelCol"
                      :wrapperCol="wrapperCol"
                      label="身份证"
                      hasFeedback
              >
                <a-input  v-decorator="[
              'num',
              {rules: [{ required: true, message: '请输入身份证' }]}
            ]"
                          placeholder="请输入身份证"/>
              </a-form-item>
            </a-col>
          </a-row>

          <a-row :gutter="48">
            <a-col :md="12" :sm="24">
              <a-form-item
                      :labelCol="labelCol"
                      :wrapperCol="wrapperCol"
                      label="性别"
                      hasFeedback
              >
                <a-input  v-decorator="[
              'sex',
              {rules: [{ required: true, message: '请输入性别' }]}
            ]"
                          placeholder="请输入性别"/>
              </a-form-item>
            </a-col>

            <a-col :md="12" :sm="24">
              <a-form-item
                      :labelCol="labelCol"
                      :wrapperCol="wrapperCol"
                      label="手机"
                      hasFeedback
              >
                <a-input  v-decorator="[
              'phone',
              {rules: [{ required: true, message: '请输入手机' }]}
            ]"
                          placeholder="请输入手机"/>
              </a-form-item>
            </a-col>
          </a-row>



          <a-row :gutter="48">
            <a-col :md="12" :sm="24">
              <a-form-item
                      :labelCol="labelCol"
                      :wrapperCol="wrapperCol"
                      label="服务套餐"
                      hasFeedback
              >

                <a-select
                        showSearch
                        optionFilterProp="title"
                        v-model="userFormData.service_id"
                        placeholder="选择服务套餐"
                        allowClear
                >
                  <a-select-option v-for="(option,index) in serviceTypeOptions" :value="option.id">{{option.name}}</a-select-option>

                </a-select>

              </a-form-item>
            </a-col>

          </a-row>


          <a-divider>申报信息</a-divider>



          <a-row :gutter="48">
            <a-col :md="12" :sm="24">
              <a-form-item
                      :labelCol="labelCol"
                      :wrapperCol="wrapperCol"
                      label="已有裁判等级（舞蹈）"
                      hasFeedback
              >
                <a-input
                        v-model="userFormData.caipandengjiwudao"
                          placeholder=""/>
              </a-form-item>
            </a-col>

            <a-col :md="12" :sm="24">
              <a-form-item
                      :labelCol="labelCol"
                      :wrapperCol="wrapperCol"
                      label="申报裁判等级（舞蹈）"
                      hasFeedback
              >
                <a-input
                        v-model="userFormData.caipanshenbaowudao"
                          placeholder=""/>
              </a-form-item>
            </a-col>
          </a-row>

          <a-row :gutter="48">
            <a-col :md="12" :sm="24">
              <a-form-item
                      :labelCol="labelCol"
                      :wrapperCol="wrapperCol"
                      label="已有裁判等级（技巧）"
                      hasFeedback
              >
                <a-input
                        v-model="userFormData.caipandengjijiqiao"
                          placeholder=""/>
              </a-form-item>
            </a-col>

            <a-col :md="12" :sm="24">
              <a-form-item
                      :labelCol="labelCol"
                      :wrapperCol="wrapperCol"
                      label="申报裁判等级（技巧）"
                      hasFeedback
              >
                <a-input
                        v-model="userFormData.caipanshenbaojiqiao"
                          placeholder=""/>
              </a-form-item>
            </a-col>
          </a-row>


          <a-row :gutter="48">
            <a-col :md="12" :sm="24">
              <a-form-item
                      :labelCol="labelCol"
                      :wrapperCol="wrapperCol"
                      label="已有教练等级（舞蹈）"
                      hasFeedback
              >
                <a-input
                        v-model="userFormData.jiaoliandengjiwudao"
                        placeholder=""/>
              </a-form-item>
            </a-col>

            <a-col :md="12" :sm="24">
              <a-form-item
                      :labelCol="labelCol"
                      :wrapperCol="wrapperCol"
                      label="申报教练等级（舞蹈）"
                      hasFeedback
              >
                <a-input
                        v-model="userFormData.jiaolianshenbaowudao"
                        placeholder=""/>
              </a-form-item>
            </a-col>
          </a-row>


          <a-row :gutter="48">
            <a-col :md="12" :sm="24">
              <a-form-item
                      :labelCol="labelCol"
                      :wrapperCol="wrapperCol"
                      label="已有教练等级（技巧）"
                      hasFeedback
              >
                <a-input
                        v-model="userFormData.jiaoliandengjijiqiao"
                        placeholder=""/>
              </a-form-item>
            </a-col>

            <a-col :md="12" :sm="24">
              <a-form-item
                      :labelCol="labelCol"
                      :wrapperCol="wrapperCol"
                      label="申报教练等级（技巧）"
                      hasFeedback
              >
                <a-input
                        v-model="userFormData.jiaolianshenbaojiqiao"
                        placeholder=""/>
              </a-form-item>
            </a-col>
          </a-row>


        </a-form>
        </a-spin>

      <template slot="footer">
        <a-button key="cancel" @click="handleUserFormCancel">取消</a-button>
        <a-button key="forward" :loading="saveLoading" type="primary" @click="handleUserFormOk">保存</a-button>
      </template>
      </a-modal>


  </a-card>
  </template>

  <script>
  import STable from '@/components/table/'
  import ATextarea from 'ant-design-vue/es/input/TextArea'
  import AInput from 'ant-design-vue/es/input/Input'
  import EditableCell from '@/components/EditableCell/'
  import PicUploader from '@/components/PicUploader/'
  import FileUploader from '@/components/FileUploader/'
  import JiaolianPicker from '@/components/JiaolianPicker/'
  import CaipanPicker from '@/components/CaipanPicker/'
  import areaOptions from '@/utils/area'
  import moment from 'moment'
  import qs from 'qs'
  import setting from '@/config/setting'
  import 'moment/locale/zh-cn';
  moment.locale('zh-cn');

  import { getMemberList ,getApplyDetail,getServiceTypeList,editApply ,applyDelete ,sjsqOptions ,getApplyOrderDetail ,editApplyOrder,getApplyUserDetail,editApplyUser} from '@/api/caipan'
  export default {
    name: 'KaojiApplyList',
    components: {
      AInput,
      ATextarea,
      FileUploader,
      PicUploader,
      STable,
      EditableCell,
      CaipanPicker,
      JiaolianPicker,
    },
    data () {
      return {
        areaOptions,
        visible: false,
        orderVisible: false,
        saveLoading:false,
        userFormVisible:false,
        jiaolianPickerShow:false,
        caipanPickerShow:false,
        sjsqOptions:[],
        orderFormData:{

        },
        formData:{
          id:0,
          danwei:'',
          areas:[],
          member_list:[],
          loglist:[],
        },
        time_range_moment:[],
        time_range:[],
        labelCol: {
//          xs: { span: 24 },
//          sm: { span: 5 },
          xs: { span: 24 },
          sm: { span: 8 },
        },
        wrapperCol: {
          xs: { span: 24 },
          sm: { span: 12 },
        },
        form: this.$form.createForm(this),
        form3: this.$form.createForm(this),
        mdl: {},

        // 高级搜索 展开/关闭
        advanced: false,
        // 查询参数
        queryParam: {
          namekey_pre:'',
          keywords:'',
          sjsq:[]
        },
        // 表头
        columns: [
          {
            title: '#',
            dataIndex: 'id',
            width: '50px'
          },
          {
            title: '人员信息',
            dataIndex: 'danwei',
            scopedSlots: { customRender: 'danwei' },
          },
          {
            title: '等级',
            dataIndex: 'grade',
            scopedSlots: { customRender: 'grade' },
          },
          {
            title: '状态',
            dataIndex: 'status',
            scopedSlots: { customRender: 'status' },
          },
          {
            title: '操作',
            dataIndex: 'action',
            fixed: 'right',
            width: 220,
            scopedSlots: { customRender: 'action' },
          }
        ],
        // 表头
        subjectColumns: [
          {
            title: '#',
            dataIndex: 'id',
            width: '50px'
          },
          {
            title: '姓名',
            dataIndex: 'name',
            scopedSlots: { customRender: 'name' },
          },
          {
            title: '电话',
            dataIndex: 'phone',
          },
          {
            title: '微信',
            dataIndex: 'weixin',
          },
          {
            title: '套餐',
            dataIndex: 'service',
            scopedSlots: { customRender: 'service' },
          },
          {
            title: '操作',
            dataIndex: 'action',
            fixed: 'right',
            width: 120,
            scopedSlots: { customRender: 'action' },
          }
        ],
        // 加载数据方法 必须为 Promise 对象
        loadData: parameter => {
          console.log('loadData');
          console.log(this.queryParam);
          let that= this;

          if (this.time_range_moment[0] && this.time_range_moment[1]) {
            this.queryParam.time_range = [
              this.time_range_moment[0].format('YYYY-MM-DD HH:mm:ss'),
              this.time_range_moment[1].format('YYYY-MM-DD HH:mm:ss')
            ]
          } else {
            this.queryParam.time_range = []
          }

          this.queryParam = Object.assign(this.queryParam,parameter);
          return getMemberList(this.queryParam)
            .then(res => {
              console.log('res');
              this.queryParam.namekey_pre = res.data.namekey_pre
              return res.data
            })
        },

        selectedRowKeys: [],
        selectedRows: [],
        cashFormData:{
          ids:[],
          to_type:'',
          price:0,
          note:'',
          count:0,
        },
        serviceTypeOptions:[],
        userFormData:{
          id:0,
          name:'',
          "caipandengjiwudao":"",
          "caipandengjijiqiao":"",
          "jiaoliandengjiwudao":"",
          "jiaoliandengjijiqiao":"",
          "caipanshenbaowudao":"",
          "caipanshenbaojiqiao":"",
          "jiaolianshenbaowudao":"",
          "jiaolianshenbaojiqiao":"",
        }
      }
    },
    computed:{
    },

    created(){
    },

    mounted(){
      let that = this;

      let query  = this.$route.query;
      // 6, 276
      console.log(query)
      if(query.saiji) {
        this.queryParam.sjsq = [query.saiji, query.saiqu]
      }
      that.getSjsqOptions();
    },
    methods: {
      moment,
      getSjsqOptions(){
        let that = this;
        sjsqOptions({}).then(res =>{
          that.sjsqOptions = res.data;
        });
      },
      handleCancel(){
        this.visible = false
      },
      handleOrderCancel(){
        this.orderVisible = false
      },
      //展开关闭
      toggleAdvanced() {
        this.advanced = !this.advanced
      },



      handleEdit(record){
        let self = this
        this.visible = true
        getApplyDetail({ id: record.id }).then(res => {
          setTimeout(() =>{
            self.form.setFieldsValue({ ...res.data })
            self.formData.id = record.id;
            console.log('handleEdit')
            if(res.data.area){
              res.data.areas = [res.data.area.substring(0,2)+'0000',res.data.area.substring(0,4)+'00',res.data.area];
            }else{
              res.data.areas = [];
            }
            self.formData = { ...res.data };
          },200)
        })
        // console.log(this.mdl)
      },
      handleOrderEdit(record){
        let self = this
        getApplyOrderDetail({ baoming_id: record.id }).then(res => {
          self.orderVisible = true
          setTimeout(() =>{
            self.orderFormData.id = record.id;
            console.log('handleEdit')

            self.orderFormData = { ...res.data };
          },200)
        }).catch(err =>{
          self.$message.error(err.data.msg);
        })
        // console.log(this.mdl)
      },
    // 查
    onSearch() {
      let self = this;
      self.$refs.table.refresh(false)
    },

      // 增改 处理
      handleOk(e) {
        let self = this;
        e.preventDefault()
        if(self.formData.areas.length!=3){
          self.$message.error('请选择完整地区');
          return ;
        }
        this.form.validateFields((err, values) => {
          if (!err) {
            console.log('Received values of form: ', values)
            console.log('Received valuess of formData: ', self.formData)
            self.saveLoading = true;
            editApply({
              id:self.formData.id,
              danwei:self.formData.danwei,
              ldname:self.formData.ldname,
              weixin:self.formData.weixin,
              email:self.formData.email,
              phone:self.formData.phone,
              fapiao_taitou:self.formData.fapiao_taitou,
              fapiao_shuihao:self.formData.fapiao_shuihao,
              fapiao_beizhu:self.formData.fapiao_beizhu,
              fapiao_email:self.formData.fapiao_email,
              fapiao_phone:self.formData.fapiao_phone,
              memberstatus:self.formData.memberstatus,
              area:self.formData.areas[self.formData.areas.length-1],
              address:self.formData.address,
            }).then(res => {
              self.$message.success('修改成功')
              self.$refs.table.refresh(false)
              self.visible = false;
              self.saveLoading = false;
            }).catch(err =>{
              self.$message.error(err.data.msg);
              self.saveLoading = false;
            })
          }
        })
      },
      // 增改 处理
      handleOrderOk(e) {
        let self = this;
        e.preventDefault();

        self.saveLoading = true;
        editApplyOrder({
          id:self.orderFormData.id,
          baoming_id:self.orderFormData.baoming_id,
          status:self.orderFormData.status,
          adminnote:self.orderFormData.adminnote,
          memberprice:self.orderFormData.memberprice,
          pay_price:self.orderFormData.pay_price,
        }).then(res => {
          self.$message.success('修改成功')
          self.$refs.table.refresh(false)
          self.orderVisible = false;
          self.saveLoading = false;
        }).catch(err =>{
          self.$message.error(err.data.msg);
          self.saveLoading = false;
        })
      },

      // 删
      applyDelete(record) {
        let self = this
        applyDelete({ id: record.id }).then(res => {
          self.$message.success('删除成功')
          self.$refs.table.refresh()
        }).catch(err =>{
          self.$message.error(err.data.msg)
        })
      },
      // 删
      applyDeleteAll() {
        let self = this
        applyDelete({ ids: self.selectedRowKeys ,id:0 }).then(res => {
          self.$message.success('删除成功')
          self.$refs.table.refresh()
        }).catch(err =>{
          self.$message.error(err.data.msg)
        })
      },


      onEditUser(record){
        let self = this
        this.userFormVisible = true
        getApplyUserDetail({ id: record.id }).then(res => {
          setTimeout(() =>{
            self.form3.setFieldsValue({ ...res.data })
            self.userFormData.id = record.id;
            self.userFormData = { ...res.data };
          },200)
        });
        getServiceTypeList({ saiqu: self.formData.saiqu }).then(res => {
          setTimeout(() =>{
            self.serviceTypeOptions = res.data
          },200)
        });
      },
      handleUserFormCancel(){
        this.userFormVisible = false
      },


      handleUserFormOk(e) {
        let self = this;
        e.preventDefault()
        this.form3.validateFields((err, values) => {
          if (!err) {
            console.log('Received values of form: ', values)
            console.log('Received valuess of formData: ', self.userFormData)
            self.saveLoading = true;
            editApplyUser({
              id:self.userFormData.id,
              name:values.name,
              num:values.num,
              phone:values.phone,
              sex:values.sex,
              service_id:self.userFormData.service_id,
              caipandengjiwudao:self.userFormData.caipandengjiwudao,
              caipandengjijiqiao:self.userFormData.caipandengjijiqiao,
              jiaoliandengjiwudao:self.userFormData.jiaoliandengjiwudao,
              jiaoliandengjijiqiao:self.userFormData.jiaoliandengjijiqiao,
              caipanshenbaowudao:self.userFormData.caipanshenbaowudao,
              caipanshenbaojiqiao:self.userFormData.caipanshenbaojiqiao,
              jiaolianshenbaowudao:self.userFormData.jiaolianshenbaowudao,
              jiaolianshenbaojiqiao:self.userFormData.jiaolianshenbaojiqiao,
            }).then(res => {
              self.$message.success('修改成功')
              self.userFormVisible = false;
              self.saveLoading = false;
            }).catch(err =>{
              self.$message.error(err.data.msg);
              self.saveLoading = false;
            })

          }
        })
      },


    download(type) {
      console.log("this.queryParam");
      console.log(this.queryParam);
      // if (typeof this.queryParam.sjsq == 'undefined' || this.queryParam.sjsq.length != 2) {
      // this.$message.error('请先选择赛区');
      // return;
      // }
      switch (type) {
        case 1:
          window.open(
            setting.apiBaseURL +
              "/wyhadminapi/caipan/shengCpDownload?" +
              qs.stringify(this.queryParam)
          );
          break;
      }
    },
    downloadCert(record){
      window.open(setting.apiBaseURL+''+record.cert_url)
    },
    onSelectChange (selectedRowKeys, selectedRows) {
        this.selectedRowKeys = selectedRowKeys
        this.selectedRows = selectedRows
      },

    },
    filters:{
    },
    watch: {
    }
  }
</script>
